import { InstrumentationProvider } from './monitoring-providers.enum';

export function getMonitoringProvider() {
  const vercelEnv = process.env.VERCEL_ENV;
  const isLocalDev = process.env.NODE_ENV === 'development' && !vercelEnv;

  if (isLocalDev) {
    // Skip heavy monitoring providers in local dev to speed up boot and avoid noisy deps
    return undefined;
  }

  return process.env.NEXT_PUBLIC_MONITORING_PROVIDER as
    | InstrumentationProvider
    | undefined;
}
